import { h, Component } from 'preact';
import styles from './style.scss';

export class Citation extends Component {
  render(props) {
    return (
      props.citation && (
        <div className={styles.citation}>
          <div>{props.citation.text}</div>
          {props.citation.author && (
            <div className={styles.author}>{props.citation.author}</div>
          )}
        </div>
      )
    );
  }
}
